import { injectable } from 'inversify';
import { ViewStateService } from '../../../state/reduxViewServices/view.service';
import {
  AddConneqtViewState,
  ViewStates,
} from '../../../state/reduxViewServices/view.slice';

@injectable()
export class AddConneqtView extends ViewStateService<AddConneqtViewState> {
  constructor() {
    super(ViewStates.addConneqt);
  }
}
